<template>
  <div id="modal" class="modal modal-video short" role="dialog">
    <button
      type="button"
      class="btn-close"
      @click="close"
      aria-label="Close modal"
      title="Close"
    >
      ×
    </button>

    <section class="modal-body">
      <block-video :src="payload.src" aspect="9-16"></block-video>
    </section>

  </div>
</template>

<script>
  export default {
    name: 'Video',

    props: {
    	payload: {
    		type: [Object,String]
    	}
    },

    data() {
      return {

      }
    },

    created() {
      if (!this.payload.src) {
        this.close();
      }
    },

    methods: {
      close() {
        this.$emit('close')
      },
    },
  };
</script>
